/**
 * @generated SignedSource<<043d73a8c0c92fb2a8d15be7f4fadc8b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useReadAndWriteContentQueryDataCacheReadContentFragment$data = {
  readonly body: {
    readonly dynamic: {
      readonly representation: string | null;
      readonly value: string | null;
      readonly webresource: {
        readonly superbatch: {
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
        readonly tags: {
          readonly css: string | null;
          readonly js: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useReadAndWriteContentQueryDataCacheReadContentFragment";
};
export type useReadAndWriteContentQueryDataCacheReadContentFragment$key = {
  readonly " $data"?: useReadAndWriteContentQueryDataCacheReadContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useReadAndWriteContentQueryDataCacheReadContentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useReadAndWriteContentQueryDataCacheReadContentFragment",
  "selections": [
    {
      "concreteType": "ContentBodyPerRepresentation",
      "kind": "LinkedField",
      "name": "body",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentBody",
          "kind": "LinkedField",
          "name": "dynamic",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "representation"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "concreteType": "WebResourceDependencies",
              "kind": "LinkedField",
              "name": "webresource",
              "plural": false,
              "selections": [
                {
                  "concreteType": "SuperBatchWebResources",
                  "kind": "LinkedField",
                  "name": "superbatch",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                },
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "efb80ee4b9c32439a7531e49de8bf64e";

export default node;
